import React from 'react';
import { EditOriginalPdfForm, Header } from '../../components';

export const EditOriginalPdf = () => {
  return (
    <>
      <Header />
      <EditOriginalPdfForm />
    </>
  );
};
